import Navbar from "./Navbar";
import Home from "./home";
import CreateAccount from "./CreateAccount";
import Login from "./Login";
import Deposit from "./Deposit"
import Withdraw from "./Withdraw"
import Logout from "./Logout"
import AllData from "./AllData";


export {
    Navbar,
    Home,
    CreateAccount,
    Login,
    Logout,
    Deposit,
    Withdraw,
    AllData
}

export const API_URI = "https://billieporterfullstackbank.herokuapp.com";
